import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        const user = r.data.user;
        // CRITICAL: store the session_token as a Bearer fallback so that
        // cross-origin cookie blocks (youngblack.tv ↔ moviepass-pro-2.emergent.host)
        // can't lock us out of /content/{id} or any other protected endpoint.
        if (r.data.session_token && typeof window !== "undefined") {
          window.localStorage.setItem("ybtv_user_token", r.data.session_token);
        }
        setUser(user);
        window.history.replaceState(null, "", window.location.pathname);
        const firstName = user?.name?.split(" ")[0] || "back";
        toast.success(`Signed in — welcome ${firstName}!`);
        const target = user?.is_subscribed ? "/browse" : "/subscribe";
        navigate(target, { replace: true });
      } catch {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0E] text-white">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#E50914] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm text-gray-400 uppercase tracking-[0.2em]">Signing you in</p>
      </div>
    </div>
  );
}
